import React from 'react';
import PointCauseList from '../PointCauseList';
import PointCauseListSearchBox from '../PointCauseListSearchBox';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';

const PointCauseListWrap = (props) => {
  const { pointCauseList, setData, getList } = props;

  return (
    <div className="point-cause-list-wrap">
      <PointCauseListSearchBox
        setData={(data) =>
          setData({
            path: ['pointCauseList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={pointCauseList.searchData}
        getList={getList}
      />

      <PointCauseList
        pointCauseList={pointCauseList.list}
        initialOption={{
          pagination: _LIST_PAGINATION_MODEL,
        }}
        pagination={pointCauseList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default PointCauseListWrap;
